// extracted by mini-css-extract-plugin
var _1 = "PciWg";
var _2 = "ZxShO";
var _3 = "Qzws9";
export { _1 as "base", _2 as "form", _3 as "modalActions" }
